import { render, staticRenderFns } from "./ReadingComprehension.vue?vue&type=template&id=5bedc93f&"
import script from "./ReadingComprehension.vue?vue&type=script&lang=js&"
export * from "./ReadingComprehension.vue?vue&type=script&lang=js&"
import style0 from "./ReadingComprehension.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports